import React, { Component } from "react";
import { connect } from "react-redux";
import { Card, Table, Select, Input, Button, Tooltip, Modal, Tag } from "antd";
import {
  API_BASE,
  PAGE_SIZE,
  SORT_FIELD_NAME,
  SORT_UP_DOWN,
} from "../../utils/contrains";
import { usrRole } from "../../utils/dataUtil";
import {
  req_page_usm_space_management,
  req_downloadfile_usm_space_management,
  req_list_usm_course_roomcode,
  req_list_usm_storage_goods,
  req_list_usm_all_course_roomcode,
} from "../../api";

import SpaceCourseRoomModal from "./space-course-room-modal";
import SpaceStorageGoodsModal from "./space-storage-goods-modal";
import SpaceRoomCourseListModal from "./space-room-course-list-modal";
class SpaceManagementSearch extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  state = {
    deviceWidth: 0,
    loading: false,
    userLevel: "NORMAL",
    items: [],
    courseRooms: [],
    storageGoods: [],
    roomCourses: [],
    item: {},
    pagination: {
      current: 1,
      pageSize: PAGE_SIZE,
      total: 0,
    },
    columnSort: SORT_FIELD_NAME,
    orderBy: SORT_UP_DOWN,
    searchField: "NONE",
    searchValue: "",
    filterStatus: "",
    isShowCourseModal: false,
    isShowStorageModal: false,
    isShowCoursesModal: false,
  };

  UNSAFE_componentWillMount() {
    this.init_columns();
  }

  componentDidMount() {
    this.api_page_items(1);
  }

  // 遠端數據處理 //////////////////////////////////////////////
  api_page_items = async (current) => {
    const { pageSize } = this.state.pagination;
    const { searchField, searchValue, columnSort, orderBy, filterStatus } =
      this.state;
    const { token, userCode, role } = this.props.user;
    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel });

    this.setState({ loading: true, items: [] });
    const result = await req_page_usm_space_management(
      "NORMAL",
      userCode,
      current,
      pageSize,
      columnSort,
      orderBy,
      searchField,
      searchValue,
      filterStatus,
      token
    );

    // console.log(result);
    if (result.total > 0) {
      const { total } = result;
      const items = result.data;
      const pagination = {
        current: this.current,
        pageSize: this.state.pagination.pageSize,
        total,
      };
      this.setState({ items, pagination, loading: false });
      //console.log(this.state);
    } else {
      const items = [];
      const pagination = {
        current: 1,
        pageSize: this.state.pagination.pageSize,
        total: 0,
      };
      this.setState({ items, pagination, loading: false });
    }
  };

  api_downloadfile_items = async () => {
    const { searchField, searchValue, filterStatus } = this.state;
    const { token, userCode } = this.props.user;

    const fileUrl = await req_downloadfile_usm_space_management(
      "NORMAL",
      userCode,
      searchField,
      searchValue,
      filterStatus,
      token
    );

    // download file link
    let a = document.createElement("a");
    a.href = API_BASE + fileUrl;
    a.target = "_blank";
    a.download = "清單";
    a.click();
  };

  api_list_course_rooms = async (key) => {
    const { token } = this.props.user;
    this.setState({ rooms: [] });
    const result = await req_list_usm_course_roomcode(key, token);
    // console.log(result);
    if (result.total > 0) {
      const courseRooms = result.data;
      this.setState({ courseRooms, isShowCourseModal: true });
      //console.log(this.state);
    } else {
      const courseRooms = [];
      this.setState({ courseRooms });
    }
  };

  api_list_storage_goods = async (key) => {
    const { token } = this.props.user;
    this.setState({ rooms: [] });
    const result = await req_list_usm_storage_goods(key, token);
    // console.log(result);
    if (result.total > 0) {
      const storageGoods = result.data;
      this.setState({ storageGoods, isShowStorageModal: true });
      //console.log(this.state);
    } else {
      const storageGoods = [];
      this.setState({ storageGoods });
    }
  };

  api_list_room_courses = async (key) => {
    const { token } = this.props.user;
    this.setState({ rooms: [] });
    const result = await req_list_usm_all_course_roomcode(key, token);
    // console.log(result);
    if (result.total > 0) {
      const roomCourses = result.data;
      this.setState({ roomCourses, isShowCoursesModal: true });
      //console.log(this.state);
    } else {
      const roomCourses = [];
      this.setState({ roomCourses });
    }
  };

  // 數據配置設定 //////////////////////////////////////////////

  init_columns = () => {
    this.columns = [
      {
        title: "空間編號",
        dataIndex: "SpaceCode",
        width: 24,
        fixed: "left",
      },
      {
        title: "空間名稱",
        width: 50,
        fixed: "left",
        render: (item) => {
          const { SpaceStandardTwName, SpaceStandardEnName } = item;
          return (
            <>
              {SpaceStandardTwName}
              <br />
              {SpaceStandardEnName}
            </>
          );
        },
      },
      {
        title: "所在建物",
        width: 28,
        render: (item) => {
          const { BuildingName, Floor } = item;
          return (
            <>
              {BuildingName}
              <br />
              {Floor}樓
            </>
          );
        },
      },
      {
        title: "面(容)積",
        width: 25,
        render: (item) => {
          const { TwPingSize, SquareMeter, Accommodate } = item;
          return (
            <>
              {TwPingSize}坪 / {Accommodate}人
              <br />
              {SquareMeter}公尺
            </>
          );
        },
      },
      {
        title: "保管單位",
        width: 28,
        render: (item) => {
          const { ShortDepartmentTwName, CustodianTwName } = item;
          return (
            <>
              {ShortDepartmentTwName}
              <br />
              {CustodianTwName}
            </>
          );
        },
      },
      {
        title: "排課狀況",
        width: 40,
        render: (item) => {
          const {
            YearSemester,
            SemesterWeekClassTotal,
            ALessonTotal,
            BLessonTotal,
            CLessonTotal,
          } = item;
          return (
            <>
              <button
                className={
                  SemesterWeekClassTotal > 0
                    ? "btn btn-outline-danger btn-sm"
                    : "btn btn-outline-secondary btn-sm"
                }
                disabled={SemesterWeekClassTotal === 0 ? "true" : ""}
                onClick={() => this.handle_show_ui_modal("COURSELIST", item)}
              >
                學年期：{YearSemester} 總：{SemesterWeekClassTotal}
              </button>
              <br />
              <Tag color={ALessonTotal > 0 ? "orange" : ""}>
                日：{ALessonTotal}
              </Tag>
              <Tag color={BLessonTotal > 0 ? "blue" : ""}>
                進：{BLessonTotal}
              </Tag>
              <Tag color={CLessonTotal > 0 ? "green" : ""}>
                它：{CLessonTotal}
              </Tag>
            </>
          );
        },
      },
      {
        title: "",
        width: 50,
        fixed: "right",
        render: (item) => {
          const { CourseSpaceTotal, StorageGoodsTotal } = item;
          return (
            <>
              <button
                className={
                  CourseSpaceTotal > 0
                    ? "btn btn-outline-danger btn-sm"
                    : "btn btn-outline-secondary btn-sm"
                }
                style={{ width: "90px" }}
                onClick={() =>
                  this.handle_show_ui_modal("COURSEROOMSLIST", item)
                }
                disabled={CourseSpaceTotal > 0 ? false : true}
              >
                <i className="fa fa-book"></i> 課務({CourseSpaceTotal})
              </button>
              <button
                className={
                  StorageGoodsTotal > 0
                    ? "btn btn-outline-danger btn-sm"
                    : "btn btn-outline-secondary btn-sm"
                }
                style={{ width: "90px" }}
                onClick={() =>
                  this.handle_show_ui_modal("STORAGEGOODSLIST", item)
                }
                disabled={StorageGoodsTotal > 0 ? false : true}
              >
                <i className="fa fa-shopping-cart"></i> 會總({StorageGoodsTotal}
                )
              </button>
            </>
          );
        },
      },
    ];
  };

  // 操作互動處理 //////////////////////////////////////////////
  handle_data_refresh = () => {
    this.api_page_items(this.current);
  };

  handle_page_size_change = (current, size) => {
    //console.log(size)
    this.setState(
      {
        pagination: {
          current: current,
          pageSize: size,
        },
      },
      () => {
        this.api_page_items(current);
      }
    );
  };

  handle_table_change = (pagination, filters, sorter, extra) => {
    if (filters) {
      const status = [...Object.values(filters).filter(Boolean)][0];
      if (status) {
        this.setState({ filterStatus: status }, () => {
          this.api_page_items(pagination.current);
        });
      } else {
        this.setState({ filterStatus: "" }, () => {
          this.api_page_items(pagination.current);
        });
      }
    } else {
      this.api_page_items(pagination.current);
    }
  };

  handle_show_ui_modal = (type, item) => {
    //console.log(item);
    const { SpaceCode } = item;
    switch (type) {
      case "EXPORT":
        this.api_downloadfile_items();
        break;
      case "COURSEROOMSLIST":
        this.api_list_course_rooms(SpaceCode);
        break;
      case "STORAGEGOODSLIST":
        this.api_list_storage_goods(SpaceCode);
        break;
      case "COURSELIST":
        this.api_list_room_courses(SpaceCode);
        break;

      default:
    }
    this.setState({ item: item });
  };

  //////////////////////////////////////////////////////////
  render() {
    const {
      loading,
      items,
      pagination,
      searchField,
      searchValue,
      isShowCourseModal,
      isShowStorageModal,
      isShowCoursesModal,
      courseRooms,
      storageGoods,
      roomCourses,
    } = this.state;
    const title = (
      <>
        <Select
          value={searchField}
          style={{ width: 120 }}
          onChange={(value) => this.setState({ searchField: value })}
        >
          <Select.Option value="NONE">搜索條件</Select.Option>
          <Select.Option value="BuildingName">所在建物</Select.Option>
          <Select.Option value="Floor">樓層</Select.Option>
          <Select.Option value="SpaceCode">空間編號</Select.Option>
          <Select.Option value="SpaceStandardTwName">
            空間中文名稱
          </Select.Option>
          <Select.Option value="ShortDepartmentTwName">保管單位</Select.Option>
          <Select.Option value="CustodianTwName">保管人</Select.Option>
        </Select>
        <Input
          placeholder="關鍵字"
          style={{ width: 100, margin: "0 5px" }}
          value={searchValue}
          onChange={(event) =>
            this.setState({ searchValue: event.target.value })
          }
        />
        <Tooltip placement="top" title="重新整理">
          <Button type="primary" onClick={() => this.handle_data_refresh()}>
            <i className="fas fa-sync-alt"></i>
          </Button>
        </Tooltip>{" "}
        <Button type="primary" onClick={() => this.api_page_items(1)}>
          <i className="fas fa-search" style={{ paddingRight: "4px" }}></i> 查詢
        </Button>
        <p></p>
      </>
    );
    return (
      <>
        {title}
        <Card>
          <Table
            bordered
            scroll={{ x: 800, y: 380 }}
            loading={loading}
            rowKey="Uid"
            columns={this.columns}
            dataSource={items}
            onChange={this.handle_table_change}
            pagination={{
              ...pagination,
              responsive: true,
              showQuickJumper: true,
              showSizeChanger: true,
              pageSizeOptions: [5, 10, 20, 50, 100],
              // onChange: this.api_page_applycase,
              onShowSizeChange: this.handle_page_size_change,
            }}
          />
        </Card>
        <Modal
          destroyOnClose={true}
          visible={isShowCourseModal}
          okText="關閉"
          onOk={() => {
            this.setState({ isShowCourseModal: false });
          }}
          onCancel={() => {
            this.setState({ isShowCourseModal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <SpaceCourseRoomModal rooms={courseRooms} />
        </Modal>
        <Modal
          destroyOnClose={true}
          visible={isShowStorageModal}
          okText="關閉"
          onOk={() => {
            this.setState({ isShowStorageModal: false });
          }}
          onCancel={() => {
            this.setState({ isShowStorageModal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <SpaceStorageGoodsModal goods={storageGoods} />
        </Modal>
        <Modal
          destroyOnClose={true}
          visible={isShowCoursesModal}
          okText="關閉"
          onOk={() => {
            this.setState({ isShowCoursesModal: false });
          }}
          onCancel={() => {
            this.setState({ isShowCoursesModal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <SpaceRoomCourseListModal rooms={roomCourses} />
        </Modal>
      </>
    );
  }
}
export default connect(
  (state) => ({ user: state.user }),
  {}
)(SpaceManagementSearch);
